var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAction1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.143,
    height: 17.571,
    viewBox: "0 0 26.143 17.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44350",
    "data-name": "Group 44350",
    transform: "translate(-40.853 -325.853)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44246",
    "data-name": "Group 44246",
    transform: "translate(41 326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88451",
    "data-name": "Path 88451",
    d: "M25.084,12V1.286A.536.536,0,0,0,24.548.75H10.619a.536.536,0,0,0-.535.536V2.358",
    transform: "translate(-1.981 -0.147)",
    fill: "none",
    stroke: "#9c64da",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88452",
    "data-name": "Path 88452",
    d: "M15.362,14.751H28.067c0,1.607-1.071,2.143-2.678,2.143H16.978",
    transform: "translate(-2.821 -2.898)",
    fill: "none",
    stroke: "#9c64da",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88453",
    "data-name": "Path 88453",
    d: "M6.631,11.181A2.971,2.971,0,0,1,3.417,8.425V7.506A2.971,2.971,0,0,1,6.631,4.751,2.971,2.971,0,0,1,9.845,7.506v.919A2.971,2.971,0,0,1,6.631,11.181Z",
    transform: "translate(-0.671 -0.933)",
    fill: "none",
    stroke: "#9c64da",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88454",
    "data-name": "Path 88454",
    d: "M.75,19.571v-.964c0-2.643,3.451-3.857,5.357-3.857s5.357,1.192,5.357,3.835v.987",
    transform: "translate(-0.147 -2.898)",
    fill: "none",
    stroke: "#9c64da",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88455",
    "data-name": "Path 88455",
    d: "M18.893,8.774a2.2,2.2,0,0,0,2.143-2.3V5.713a2.148,2.148,0,1,0-4.286,0v.766A2.2,2.2,0,0,0,18.893,8.774Z",
    transform: "translate(-3.291 -0.671)",
    fill: "none",
    stroke: "#9c64da",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88456",
    "data-name": "Path 88456",
    d: "M21.845,12.226c0-1.467-2.071-2.143-3.214-2.143s-3.214.663-3.214,2.13",
    transform: "translate(-3.029 -1.981)",
    fill: "none",
    stroke: "#9c64da",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAction1);
export default __webpack_public_path__ + "static/media/action_1.db409fcc80bc40369a69d0e131ffb47c.svg";
export { ForwardRef as ReactComponent };